import { render, staticRenderFns } from "./UnitRepresentativeChange.vue?vue&type=template&id=0a3db420&scoped=true&"
import script from "./UnitRepresentativeChange.vue?vue&type=script&lang=js&"
export * from "./UnitRepresentativeChange.vue?vue&type=script&lang=js&"
import style0 from "./UnitRepresentativeChange.vue?vue&type=style&index=0&id=0a3db420&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3db420",
  null
  
)

export default component.exports